import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type { CosignMetaBody } from "@/core/types";

export async function getCosignatureMeta(noteId: string): Promise<CosignMetaBody> {
  return cosignatureRequestsTyped.get_cosign_meta({ urlParams: { noteId } });
}
